import { render } from "./TopNavLinks.vue?vue&type=template&id=bda18872&scoped=true"
import script from "./TopNavLinks.vue?vue&type=script&lang=js"
export * from "./TopNavLinks.vue?vue&type=script&lang=js"

import "./TopNavLinks.vue?vue&type=style&index=0&id=bda18872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda18872"]])

export default __exports__